export const tables = [
  {
    id: 23,
    value:'21'
  },
  {
    id: 24,
    value:'22'
  },
  {
    id: 25,
    value:'23'
  },
  {
    id: 26,
    value:'24'
  },
  {
    id: 27,
    value:'25'
  },
  {
    id: 28,
    value:'31'
  },
  {
    id: 29,
    value:'32'
  },
  {
    id: 30,
    value:'33'
  },
  {
    id: 31,
    value:'34'
  },
  {
    id: 32,
    value:'35'
  },
  {
    id: 33,
    value:'41'
  },
  {
    id: 34,
    value:'42'
  },
  {
    id: 35,
    value:'43'
  },
  {
    id: 36,
    value:'44'
  },
  {
    id: 37,
    value:'45'
  },
  {
    id: 38,
    value:'51'
  },
  {
    id: 39,
    value:'52'
  },
  {
    id: 40,
    value:'53'
  },
  {
    id: 41,
    value:'54'
  },
  {
    id: 42,
    value:'55'
  },
  {
    id: 43,
    value:'61'
  },
  {
    id: 44,
    value:'62'
  },
  {
    id: 45,
    value:'63'
  },
  {
    id: 46,
    value:'64'
  },
  {
    id: 47,
    value:'65'
  },
  {
    id: 48,
    value:'74'
  },
  {
    id: 49,
    value:'75'
  }
];
